module.exports = __webpack_public_path__ + "img/features-split-top-01.fe5a0827.png";